<template>
	<transition name="pop-fade">
		<div class="goToTop pop-fade-container" v-show="visiable">
			<img src="@/assets/images/go_to_top.png" alt="" @click="goToTop">
		</div>
	</transition>
</template>

<script>
import debounce from "@/utils/debounce.js";
export default {
	data() {
		return {
			visiable: false,
		}
	},
	mounted(){
		window.addEventListener('scroll',debounce(this.listener,60,100))
	},
	methods:{
		listener(){
			if(window.scrollY!=0){
				this.visiable = true;
			}else{
				this.visiable = false;
			}
		},
		goToTop(){
			window.scrollTo(0,0)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
@import "~@/scss/transition.scss";
.goToTop{
	@include square(90);
	position: fixed;
	bottom: px2rem(160);
	right: px2rem(20);	
	img{
		@include square(100);
	}
}
</style>
